import { AnnouncementComponent } from "./announcements/announcement-component";
import { NotificationComponent } from "./notifications/notification-component";

const { initSentry } = require("./common/helper");

export class NotificationsComponent {
    constructor() {
        initSentry();
        this.copyOfRenderedJson = {};
        this.bindedClickEventsArr = [];
        this.options = {};
        this.annoucementJson = {};
    }
};

function applyMixins(derivedCtor, constructors) {
    constructors.forEach((baseCtor) => {
      Object.getOwnPropertyNames(baseCtor.prototype).forEach((name) => {
        let constructorName;
        if(name == 'constructor') {
            constructorName = baseCtor.prototype[name].name;
        }
        Object.defineProperty(
          derivedCtor.prototype,
          (constructorName ?? name),
          Object.getOwnPropertyDescriptor(baseCtor.prototype, name) ||
            Object.create(null)
        );
      });
    });
  }

applyMixins(NotificationsComponent, [AnnouncementComponent, NotificationComponent]);

// Load Events Fired
(function fireEventOnNotificationScriptLoaded() {
  let notificationEvt = new CustomEvent('cambridgeOne.notificationComponentLoaded');
  let announcementEvt = new CustomEvent('cambridgeOne.announcementComponentLoaded');
  console.log("Notifications File Loaded")
  window.dispatchEvent(notificationEvt);
  window.dispatchEvent(announcementEvt);
})();